import { select, call, put, takeEvery } from "redux-saga/effects"

import HomePageConfigTypes from "Containers/HomePage/types"
import { getHomePagePermissionSuccessAction } from "Containers/HomePage/actions"
import { selectCurrentToken } from "Containers/Login/selectors"
import { getCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"
import { responseTypeIsError } from "Containers/App/saga"

function* getHomePagePermission({ payload }) {
  const token = yield select(selectCurrentToken)

  const { pageId } = payload
  const requestURL = `${config?.API_URL}/checkPagePermission/${pageId}`

  try {
    const response = yield call(request, requestURL, getCors({ token }))
    if (responseTypeIsError(response)) {
      console.error(`[route] => /checkPagePermission => ERROR GET => `, response)
    } else {
      yield put(getHomePagePermissionSuccessAction(response?.body))
    }
  } catch (err) {
    console.error(`[route] => /checkPagePermission => ERROR GET => `, err)
  }
}

function* homePageConfigSaga() {
  yield takeEvery(HomePageConfigTypes.GET_HOME_PAGE_PERMISSION, getHomePagePermission)
}

export default homePageConfigSaga
